import type { ConsumerStepId } from './steps';

export const CONSUMER_PATHS = {
  entry: '/clients/:clientId/consumer',
  step: '/clients/:clientId/consumer/:step',
  policyReviewDocument: '/consumer-policy-reviews/:reviewId/documents/:documentIndex',
} as const;

export const RETURN_TO_PARAM = 'returnTo';

export function consumerEntryPath(clientId: string): string {
  return `/clients/${clientId}/consumer`;
}

export function consumerStepPath(
  clientId: string,
  step: ConsumerStepId,
  returnTo?: ConsumerStepId,
): string {
  const path = `${consumerEntryPath(clientId)}/${step}`;
  return returnTo ? `${path}?${RETURN_TO_PARAM}=${returnTo}` : path;
}

/** The results slide just before the guided flow, where its first Back returns to. */
export function insightsSummaryPath(clientId: string): string {
  return `/clients/${clientId}/onboarding/insights-summary`;
}

/** Checkout for the one-time self-funding unlock; it returns to the payment-success slide. */
export function selfFundCheckoutPath(clientId: string): string {
  return `/clients/${clientId}/onboarding/d2c-checkout`;
}

/** The first planning slide the self-funding unlock opens. */
export function selfFundPlanPath(clientId: string): string {
  return `/clients/${clientId}/onboarding/cost-factors`;
}
